import { memo, useEffect, useState } from 'react'
import LazyLoad from 'react-lazyload'

import Ad from '@/components/Ad/Ad'
import { useAds } from '@/contexts/ads'

import styles from './Leaderboard.module.scss'

const Leaderboard = () => {
  const { loadAds } = useAds()
  const [randomRoll, setRandomRoll] = useState<number>(0)

  // Reroll ad every minute
  useEffect(() => {
    setRandomRoll(Math.random())
    const interval = setInterval(() => {
      setRandomRoll(Math.random())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  if (loadAds === false) return null

  /* Ad Setup:
     - (no outside ads atm)

     - Half of remainder split between SCM
     - Other half of remainder goes to EDHREC Patreon
  */
  const ad =
    randomRoll === 0 ? null : randomRoll < 1 / 16 ? (
      <Ad id='archidekt' />
    ) : randomRoll < 2 / 16 ? (
      <Ad id='cs' />
    ) : randomRoll < 3 / 16 ? (
      <Ad id='csb' />
    ) : randomRoll < 4 / 16 ? (
      <Ad id='cz' />
    ) : randomRoll < 5 / 16 ? (
      <Ad id='edhrecap' />
    ) : randomRoll < 6 / 16 ? (
      <Ad id='edhrecast' />
    ) : randomRoll < 7 / 16 ? (
      <Ad id='fabrec' />
    ) : randomRoll < 7.25 / 16 ? (
      <Ad id='spellifyDark1' />
    ) : randomRoll < 7.5 / 16 ? (
      <Ad id='spellifyDark2' />
    ) : randomRoll < 7.75 / 16 ? (
      <Ad id='spellifyLight1' />
    ) : randomRoll < 8 / 16 ? (
      <Ad id='spellifyLight2' />
    ) : randomRoll < 8 / 16 + 1 / 8 ? (
      <Ad id='edhrecPatreon' />
    ) : randomRoll < 8 / 16 + 2 / 8 ? (
      <Ad id='edhrecPatreon201' />
    ) : randomRoll < 8 / 16 + 3 / 8 ? (
      <Ad id='edhrecPatreon202' />
    ) : (
      <Ad id='edhrecPatreon203' />
    )

  if (loadAds === undefined) return <div className={styles.container} />

  return (
    <div className={styles.container}>
      <div className={styles.leaderboard}>
        <LazyLoad>{ad}</LazyLoad>
      </div>
    </div>
  )
}

export default memo(Leaderboard)
